import React from 'react';
import { Box } from '@material-ui/core';
import { Button } from '../../../common/components';
import GPayLogo from '../../icons/GPayLogo';
import ApplePayLogo from '../../icons/ApplePayLogo';
import { useWallet } from '../../providers/walletProvider';
import { useContent } from '../../../content/content-provider';

const walletIconsMap = {
  applePay: <ApplePayLogo />,
  googlePay: <GPayLogo />,
};

const PaymentButton = () => {
  const { walletType, startWalletPayment } = useWallet();
  const [content] = useContent();

  if (!walletType) return null;

  const buttonProps =
    walletType === 'unknown'
      ? { isLoading: true }
      : { onClick: startWalletPayment, startIcon: walletIconsMap[walletType] };

  return (
    <Box mb={4}>
      <Button {...buttonProps}>{content.stripe[walletType]}</Button>
    </Box>
  );
};

export default PaymentButton;
